import { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useUserGroupsUIContext } from "../UserGroupsUIContext";

const prepareFilter = (queryParams, values) => {
  const { name, definition } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name, definition };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function UserGroupsFilter() {
  // User Groups UI Context
  const userGroupsUIContext = useUserGroupsUIContext();
  const userGroupsUIProps = useMemo(() => {
    return {
      queryParams: userGroupsUIContext.queryParams,
      setQueryParams: userGroupsUIContext.setQueryParams
    };
  }, [userGroupsUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(userGroupsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, userGroupsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      userGroupsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        name: "",
        definition: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="definition"
                placeholder="Açıklaması"
                onBlur={handleBlur}
                value={values.definition}
                onChange={(e) => {
                  setFieldValue("definition", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Açıklaması</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}